import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { ProductGetIdsByExternalIdsQuery, ProductGetIdsByExternalIdsQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductGetIdsByExternalIdsQuery)
@Wrapper(ProductGetIdsByExternalIdsQueryHandlerBase)
export class ProductGetIdsByExternalIdsQueryHandler {
    public constructor(
        http: Http
    ) { }
}
